/* eslint-disable */

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { utility } from "../../../utility/utilityProvider";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";

const ArrayOfLastValueCell = (props) => {
  const field = props?.field || "";

  const getLastItem = (data) => {
    if (!Array.isArray(data) || data.length === 0) return null;

    let last = data[data.length - 1];

    // Keep drilling down if last item is an array
    while (Array.isArray(last) && last.length > 0) {
      last = last[last.length - 1];
    }

    return last;
  };

  let fieldValue = props.dataItem?.[field];
  const lastItem = getLastItem(fieldValue);

  let displayValue = "";

  if (props?.format?.trim() === "length") {
    displayValue = Array.isArray(fieldValue) ? fieldValue.length : 0;
  } else if (lastItem && props.format) {
    displayValue = lastItem?.[props.format] || "";
  } else {
    displayValue = "";
  }

  return (
    <td
      colSpan={props.colSpan}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...useTableKeyboardNavigation(props.id)}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      style={props.style}
    >
      <div style={{ height: "12px" }}>
        {displayValue}
      </div>
    </td>
  );
};

export default ArrayOfLastValueCell;